"use client";
import { jsx as n, jsxs as $ } from "react/jsx-runtime";
import { LAYERS as v } from "../../common/constants/layers.js";
import { MODAL_DURATIONS as f } from "../../common/constants/modalDurations.js";
import { isSSR as A } from "../../common/helpers/isSSR.js";
import { useModal as O } from "../../common/hooks/useModal.js";
import { boxPadding as h } from "../../common/styles/mixins/boxPadding.js";
import { overlay as k } from "../../common/styles/mixins/overlay.js";
import E from "../heading/Heading.js";
import M from "../icon-button/IconButton.js";
import N from "../portal/Portal.js";
import { css as l } from "@emotion/react";
import r from "@emotion/styled";
import { COLORS as p } from "../../tokens/colors/Colors.js";
import { MEDIA_QUERIES as s } from "../../tokens/media-queries/MediaQueries.js";
import { MOTION_EASINGS as C } from "../../tokens/motion-easings/MotionEasings.js";
import { SIZES as j } from "../../tokens/sizes/Sizes.js";
import { SPACINGS as L } from "../../tokens/spacings/Spacings.js";
import { forwardRef as P, useRef as _, useImperativeHandle as z } from "react";
const y = P(
  ({
    children: i,
    cssHeight: o,
    cssWidth: e,
    feCloseButton: a,
    feFullscreen: t,
    feInterruptive: d,
    feNoPadding: S = !1,
    feOnClose: x,
    feTitle: D,
    open: u,
    ...b
  }, I) => {
    if (A())
      return null;
    const m = _(null);
    z(I, () => m.current);
    const {
      closeModal: g,
      isOpen: c,
      willRender: w
    } = O({
      interruptive: d,
      onClose: x,
      open: u
    });
    return /* @__PURE__ */ n(N, { "data-portals": "dialog", feAppInert: c, feRender: w, children: /* @__PURE__ */ n(
      G,
      {
        ...b,
        "aria-labelledby": "dialog-heading",
        className: "fe-modal",
        "data-comp": "dialog",
        feFullscreen: t,
        onClick: (R) => {
          R.target !== m.current || d || g();
        },
        open: c,
        ref: m,
        role: "dialog",
        children: /* @__PURE__ */ $(
          T,
          {
            cssHeight: o,
            cssWidth: e,
            feFullscreen: t,
            open: c,
            children: [
              /* @__PURE__ */ $(U, { children: [
                /* @__PURE__ */ n(H, { as: "h2", feStyledAs: "h3", id: "dialog-heading", children: D }),
                !d && /* @__PURE__ */ n(
                  Q,
                  {
                    ...a,
                    "aria-label": (a == null ? void 0 : a["aria-label"]) ?? "Close",
                    as: "button",
                    feColor: "white",
                    feIcon: "close",
                    feSize: "lg",
                    onClick: g
                  }
                )
              ] }),
              /* @__PURE__ */ n(
                Y,
                {
                  cssHeight: o,
                  feFullscreen: t,
                  feNoPadding: S,
                  children: i
                }
              )
            ]
          }
        )
      }
    ) });
  }
);
y.displayName = "Dialog";
const so = y, G = r.div(
  ({ feFullscreen: i, feLayer: o, open: e }) => l`
		${k(!!e, f.in)};

		inset: 0;
		padding: ${L.md};
		position: fixed;
		z-index: ${o ?? v.dialog};

		${!i && l`
			align-items: center;
			display: flex;
			justify-content: center;
		`}
	`
), T = r.div(
  ({
    cssHeight: i,
    cssWidth: o,
    feFullscreen: e,
    open: a
  }) => l`
		background-color: ${p.white};
		display: flex;
		flex-direction: column;
		opacity: ${!a && 0};
		overflow: hidden;
		transition: opacity ${f.in}ms ${C.easeIn};
		transition-delay: ${a && `${f.in}ms`}; /* Delays transition onOpen */

		/* Default behaviour */
		${!e && l`
			flex: ${!o && "auto"};
			height: ${i};
			max-height: ${i ? "100%" : "50vh"};
			max-width: ${o && "100%"};
			width: ${o};

			@media screen and (${s.mobile}) {
				max-width: ${!o && "400px"};
			}

			@media screen and (${s.mobileMax}) and (${s.landscape}) {
				max-height: ${!i && "100%"};
			}
		`}

		${e && l`
			height: 100%;
		`}
	`
), U = r.div`
	${h("inline")};

	align-items: center;
	background-color: ${p.brand};
	display: flex;
	flex-shrink: 0;
	height: ${j.s48};
`, H = r(E)`
	color: ${p.white};
`, Q = r(M)`
	margin-left: auto;
`, Y = r.div(
  ({
    cssHeight: i,
    feFullscreen: o,
    feNoPadding: e
  }) => l`
		${!e && h()};

		height: ${o ? "inherit" : i && "100%"};
		overflow-y: auto;
	`
);
export {
  so as default
};
